import React from 'react';
import { TournamentCountdown } from '../TournamentCountdown/TournamentCountdown';
import { useSocket } from 'utils/hooks/useSocket';
import { formatCurrency } from 'utils';
import Cookies from 'js-cookie';
import { useWalletData } from 'context/WalletDataContext';
import { useTournament } from 'context/TournamentContext';
import TournamentRankingList from 'components/game/TournamentRankingList';
import type { RankingEntry } from 'types/tournament';
import { CASH_TICKER } from 'utils/cash';

import {
  RowTop,
  Wrap,
  RowContent,
  RowBelt,
  Title,
  LineText,
  TitleSecond,
  ContentTop,
  ContentBottom,
} from './styled';

type TournamentDetails = {
  data?: {
    id?: number;
    attributes?: {
      name?: string;
      end_at?: string;
      start_at?: string;
      amount_start?: number;
      market_type?: any;
      trade_type?: string;
    };
  };
};

const TournamentRanking = () => {
  const { tournamentRanking, tournamentDetails } = useSocket() as { tournamentRanking: RankingEntry[], tournamentDetails: TournamentDetails};
  const username = localStorage.getItem('username') ?? Cookies.get('username');
  const { tournamentStatus, tournamentPairList, joinedStatus } = useTournament();
  // TEAM_003: Support both legacy { data: { attributes: { ... } } }
  // and new flattened { data: { ... } } tournamentDetails shapes.
  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData ?? {};
  const tournamentType = attributes?.trade_type;
  const { totalMoneyString } = useWalletData();
  const userRanking = Array.isArray(tournamentRanking) ? tournamentRanking.find((entry) => entry.username === username) : undefined;
  const totalUSDT = tournamentType === "Margin" ? (userRanking ? userRanking.totalInUSDT : 0) : totalMoneyString;
  const tradingPair = tournamentPairList;
  const amountStart = attributes?.amount_start;
  const isInvalidDataUSDT =
    amountStart === undefined || amountStart === null || Number.isNaN(Number(amountStart));

  return (
    <Wrap>
      <ContentTop>
        <RowTop>
          <Title>{attributes?.name}</Title>
        </RowTop>
        <RowContent>
          <RowBelt>
            {(tournamentStatus === 'IN_PROGRESS' || tournamentStatus === 'BEFORE_START') ? (
              <>
                {(tournamentStatus === 'BEFORE_START') ? (
                  <>
                    <TitleSecond>Starts in</TitleSecond>
                    <TournamentCountdown date={attributes?.start_at} />
                  </>
                ) :
                  <>
                    <TitleSecond>Time left</TitleSecond>
                    <TournamentCountdown date={attributes?.end_at} />
                  </>
               }
              </>
            ) :
              <>
                <TitleSecond>Time left</TitleSecond>
                <LineText className="finishedColor">Finished</LineText>
              </>
            }
          </RowBelt>
          <RowBelt>
            <TitleSecond>Trading pair</TitleSecond>
            <LineText>{tradingPair.length === 0 ? `` : tradingPair?.length > 1 ? `Multi assets` : tradingPair[0]?.attributes?.name}</LineText>
          </RowBelt>
          <RowBelt className="lastRowBelt">
            {joinedStatus && (tournamentStatus === 'IN_PROGRESS' || tournamentStatus === 'BEFORE_START' || tournamentStatus === 'FINISHED') ? (
              <>
              {!isInvalidDataUSDT && (
                <>
                  <TitleSecond>Total asset value</TitleSecond>
                  <LineText>
                    {formatCurrency('0.00' !== totalUSDT ? totalUSDT : amountStart)} {CASH_TICKER}
                  </LineText>
                </>
              )}
              </>
            ) :
              <>
                <TitleSecond>Total asset value</TitleSecond>
                <LineText>---</LineText>
              </>
            }
          </RowBelt>
          <Title>Tournament <br />Ranking</Title>
        </RowContent>
      </ContentTop>
      <ContentBottom>
        <TournamentRankingList />
      </ContentBottom>
    </Wrap>
  );
};

export default TournamentRanking;
